export const themes = {
  default: {
    name: "default",
    bg: "whiteSmoke",
    fg: "black",
    hover: "rgb(255, 0, 204)",
    success: "rgb(140, 193, 60)",
    white: "#ffffff",
    black: "#000000",
    nero: "#212121",
    glassy: "transparent",
    whiteSmoke: "#f7f7f7",
    defaultShadow: "0 0 0.1rem rgba(130, 138, 145, 0.5)",
    darkPurple: "#a7208c",
    violetEggplant: "#9f1c84",
    persianIndigo: "#59095e",
    lavenderRose: "#fd91e7",
    primaryShadow: "0 0 0 0.1rem rgba(167, 32, 140, 0.5)",
    lavenderShadow: "0 0 0.1rem rgba(253, 145, 231, 0.5)",
    violetBlue: "#91538d",
    yellowGreen: "#8cc13c",
    lightGreen: "#9dd943",
    pixieGreen: "#c5d7a9",
    accentShadow: "0 0 0 0.1rem rgba(130, 138, 145, 0.5)",
    gray: "#818080",
    glacierWhite: "#e9e9e9",
    dimGray: "#6b6b6b",
    silver: "#c0c0c0",
    gainsboro: "#dfdfdf",
    dimPurple: "#F0EDEF",
    secondaryShadow: "0 0 0 0.1rem rgba(130, 138, 145, 0.2)",
    mistyRose: "#ffe0e0",
    cardinal: "#c92222",
    lemon: "#fff9cf",
    brightSun: "#ebad1a",
    panache: "#eef6e3",
    pastelLike: "#b7a2b3",
    dustyGray: "#a594a1",
    lightPurple: "#ddaad3",
    fordWhite: "#FFF5F5",
    ghostWhite: "#ffffff99",
    gmDarkBeige: "#515151",
    geminiGray: "#707070",
    darkShadeGray: "#383838",
    c7Silver: "#c7c7c7",
    mortar: "#515151",
    lightShadeMagenta: "#f5e5f2",
    blackLite: "#252525",
    ivoryEgg: "#F9F9F9",
    troopGreen: "#B6C4A3",
    magentaShade: "#C165AF",
    magentaPink: "#DC3B8C",
    greenCyan: "#06D6A0",
    blueMagenta: "#5B3BDC",
    blueMagenta2: "#5C44BF",
    blueMagentaMediumLight: "#aa9edc",
    blueMagentaVeryLight: "#E3E0F0",
    chiliRed: "#DC3B3B",
    cilMingDynastyWhite: "#dee2e6",
    greenGradient:
      "linear-gradient(-90deg, rgba(140, 193, 60, 1) 0%, rgba(36, 49, 17, 1) 100%)",
    purpleGradient:
      "linear-gradient(-90deg, rgba(167, 32, 140, 1) 0%, rgba(89, 9, 94, 1) 100%)",
    freshOcean: "#EBFFFA",
    aquamarine: "#61E5C3",
    soulDance: "#f9eef7",
    pinkityDrinkity: "#fcedf5",
    vantaTeal: "#f3fdfb",
    lightShadeBlueMagenta: "#F0EDFC",
    concrete: "#f3f3f3",
    hailstone: "#ECECEC",
    cottonwoodGray: "#595959",
    blue: "#4789DB",
    vanilla: "#FFF3DB",
    orange: "#DB8E35",
    summerSkies: "rgba(212, 222, 235, 0.63)",
  },
};

const actions = {
  SET_DEFAULT_THEME: "SET_DEFAULT_THEME",
  SET_HIGH_CONTRAST_THEME: "SET_HIGH_CONTRAST_THEME",
};

export default function themeReducer(
  state = {
    theme: themes.default,
    options: Object.keys(themes),
  },
  action
) {
  switch (action.type) {
    case actions.SET_DEFAULT_THEME:
      return { theme: themes.default };
    default:
      return state;
  }
}

export const mapStateToPropsTheme = (state) => {
  const { theme, options } = state.themeReducer;
  return { theme, options };
};
